import React, { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const FixAccount = () => {
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const fixAccount = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('texhub_token') || sessionStorage.getItem('texhub_token');
      const res = await fetch(`${API_URL}/api/admin/fix-user-subscription`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ plan: 'pro', add_images: 20 })
      });
      
      const data = await res.json();
      
      if (res.ok) {
        setResult(data);
        toast.success('Cuenta actualizada correctamente');
      } else {
        toast.error(data.detail || 'Error al actualizar');
      }
    } catch (error) {
      toast.error('Error de conexión');
    } finally {
      setLoading(false);
    }
  };

  if (user?.email !== 'rulo49@gmail.com') {
    return (
      <div className="p-8">
        <Card>
          <CardContent className="p-6">
            <p className="text-red-500">Acceso denegado</p>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="p-8 max-w-md mx-auto">
      <Card>
        <CardHeader>
          <CardTitle>Arreglar Cuenta</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-slate-600">
            Esto actualizará tu cuenta a Plan Premium y agregará 20 imágenes IA.
          </p>
          
          <Button 
            onClick={fixAccount} 
            disabled={loading}
            className="w-full"
            style={{ backgroundColor: '#34B772' }}
          >
            {loading ? 'Procesando...' : 'Arreglar mi cuenta'}
          </Button>

          {result && (
            <div className="mt-4 p-4 bg-green-50 rounded-lg">
              <p className="text-green-800 font-medium">Cuenta actualizada:</p>
              <ul className="text-sm text-green-700 mt-2">
                <li>Plan: {result.subscription_plan}</li>
                <li>Imágenes compradas: {result.ai_images_purchased}</li>
              </ul>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default FixAccount;
